/**
  * @class meleMarker
  * @description
  *
  * # Purpose
  * Implements `<mele-marker>` custom web element.
  *
  * # Use
  * Create element in HTML:
  * ```
  * parentEl.innerHTML += '<mele-marker></mele-marker>'
  * ```
  * Create element in JavaScript:
  * ```
  * parentEl.appendChildren({
  *   tag: 'mele-marker',
  *   ... other attributes ...
  * })
  * ```
  *
  * # Implementation notes
  *
  */

import meleItem from 'meleItem'

const PROPERTIES = _.extend({}, {
  description: { type: 'string', description: 'Detailed description' },
  actions: { type: 'array', description: 'Actions for marker' },
  heading: { type: 'number', description: 'Heading in degrees' },
  eventAction: { type: 'function', description: 'Called when action button is clicked' },
}, meleItem._properties)

export default class meleMarker extends meleItem {
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Creates internal DOM structure.
  */
  init() {
    super.init()
    this._actions = this.appendChildren({ tag: 'mele-actions', class: `empty ${this.classScope('actions')}` })
    this._description = this.appendChildren({ tag: 'mele-text', class: `empty ${this.classScope('description')}` })
    this.actionsChanged(this.actions)
    this.descriptionChanged(this.description)
  } // init

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "description"
  */
  descriptionChanged(value) {
    this._description.label = value
  } // descriptionChanged

  headingChanged(value) {
    value = parseFloat(value)
    if(isNaN(value)) value = 0
    if(this._iconright) {
      this._iconright.style.setProperty('--marker-heading', _.toString(value) + 'deg')
    } else if(this._iconleft) {
      this._iconleft.style.setProperty('--marker-heading', _.toString(value) + 'deg')
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "actions"
  */
  actionsChanged(value) {
    this._actions.innerHTML = ''
    value.forEach(action=>{
      if(typeof (action)==='string') {
        action = { key: action, label: action }
      }
      if(_.isObjectLike(action)) {
        action = _.extend({ tag: 'mele-button', type: 'markeraction' }, action)
        action.eventButtonClicked = this.eventAction.bind(this, action.key)
        this._actions.appendChildren(action)
      }
    })
  } // actions

  eventAction(action) {
    this.publish('mmMapMarkerAction', { holder: this.key, action })
  }
} // meleMarker

meleMarker._properties = PROPERTIES
meleMarker.observedAttributes = _.keys(PROPERTIES)

window.customElements.define('mele-marker', meleMarker)
